import React, { useState } from 'react';
import { Sheet, Copy, ExternalLink, X } from 'lucide-react';

interface GoogleSheetsExportModalProps {
  sheetUrl: string;
  onClose: () => void;
}

export const GoogleSheetsExportModal: React.FC<GoogleSheetsExportModalProps> = ({ sheetUrl, onClose }) => {
  const [copyLabel, setCopyLabel] = useState('Copy Link');

  const handleCopyLink = async () => {
    await navigator.clipboard.writeText(sheetUrl);
    setCopyLabel('Copied!');
    setTimeout(() => setCopyLabel('Copy Link'), 2000);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md mx-4 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
            <Sheet className="w-5 h-5 text-green-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Your Google Sheet is ready!</h2>
            <p className="text-sm text-gray-500">Anyone with the link can view it</p>
          </div>
        </div>

        <div className="bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 mb-4 text-sm text-gray-600 truncate">
          {sheetUrl}
        </div>

        <div className="flex gap-3">
          <button
            onClick={handleCopyLink}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <Copy className="w-4 h-4" />
            {copyLabel}
          </button>
          <a
            href={sheetUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all"
          >
            <ExternalLink className="w-4 h-4" />
            Open in Sheets
          </a>
        </div>
      </div>
    </div>
  );
};
